import { cva } from 'class-variance-authority';

/**
 * Styles for ForgotPasswordContainer component
 */
export const forgotPasswordContainerStyles = cva(
  [
    'w-full',
  ],
  {
    variants: {
      screen: {
        personalInfo: ['max-w-full'], // Allow card to control its own width
        mfaSelection: ['max-w-full', 'md:max-w-[396px]', 'lg:max-w-[476px]', 'mx-auto', 'mt-8', 'md:mt-12', 'lg:mt-16', 'mb-8', 'md:mb-12', 'lg:mb-16'],
        mfaCode: ['max-w-full', 'md:max-w-[396px]', 'lg:max-w-[476px]', 'mx-auto', 'mt-8', 'md:mt-12', 'lg:mt-16', 'mb-8', 'md:mb-12', 'lg:mb-16'],
        // Mobile/tablet: same as MFA. Desktop: margins live on ResetPasswordForm (lg:!mt-16 / lg:!mb-16)
        // so top/bottom stay 64px; this wrapper zeros out md:* so 48px does not persist past lg.
        resetPassword: [
          'max-w-full',
          'md:max-w-[396px]',
          'lg:max-w-[476px]',
          'mx-auto',
          'mt-8',
          'md:mt-12',
          'mb-8',
          'md:mb-12',
          'lg:mt-0',
          'lg:mb-0',
        ],
      },
    },
    defaultVariants: {},
  }
);
